import { useMutation } from '@tanstack/react-query';

import {
    FidelityAccountList,
    FidelityApplicationSection,
    FidelityCompletionRequirements,
    FidelityDownloadButton,
    FidelityDownloadFeedback,
    FidelityPacketCard,
} from '@/components/fidelity/FidelityApplicationComponents';
import { CustomerApi } from 'API';

import { accountTitle } from './account-model';
import { FidelitySmaSectionProps } from './useFidelitySmaApplications';

export const FidelityTrustApplicationView = ({
    household,
    applications,
    action,
    ssnAccess,
    checkingAccess,
}: FidelitySmaSectionProps<'trust'>) => {
    const accountGUIDs = household.accounts.map(({ account }) => account.accountGUID);

    const generate = useMutation({
        mutationFn: (guids: string[]) => CustomerApi({ hideError: true }).getSmaTrustForm({ accountGUIDs: guids }),
    });
    const title = (guid: string) => {
        const row = household.accounts.find(({ account }) => account.accountGUID === guid);
        return row ? accountTitle(row.account) : 'Account no longer available';
    };

    return (
        <FidelityApplicationSection
            name="Trust"
            hasAccounts={accountGUIDs.length > 0}
            groupCount={applications.data?.applications.length}
            checkingAccess={checkingAccess}
            ssnAccess={!!ssnAccess}
            applications={applications}
        >
            <>
                {applications.data?.applications.map((packet) => (
                    <FidelityPacketCard
                        key={packet.accountGUIDs.join(',')}
                        name="Trust"
                        accountCount={packet.accountGUIDs.length}
                        action={
                            <FidelityDownloadButton
                                download={generate}
                                variant="outline"
                                active={generate.variables === packet.accountGUIDs}
                                onClick={() => generate.mutate(packet.accountGUIDs)}
                            >
                                Generate SMA Trust Application
                            </FidelityDownloadButton>
                        }
                    >
                        <FidelityAccountList action={action} accountGUIDs={packet.accountGUIDs} title={title} />
                        <FidelityCompletionRequirements requirements={packet.completionRequirements} />
                    </FidelityPacketCard>
                ))}
            </>
            <FidelityDownloadFeedback
                download={generate}
                onRefresh={() => {
                    generate.reset();
                    void applications.refetch();
                }}
            />
        </FidelityApplicationSection>
    );
};
